import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressBookContactFormComponent } from './address-book-contact-form.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatLegacyFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule } from "@angular/material/legacy-input";
import { MatLegacyOptionModule } from "@angular/material/legacy-core";
import { MatLegacySelectModule } from "@angular/material/legacy-select";
import { TextFieldModule } from "@angular/cdk/text-field";

import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatLegacyCheckboxModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    MatLegacyOptionModule,
    MatLegacySelectModule,
    TextFieldModule,
    MatButtonModule,
    MatDialogModule,
    FlexLayoutModule
  ],
  declarations: [AddressBookContactFormComponent],
  exports : [AddressBookContactFormComponent]
})
export class AddressBookContactFormModule { }
